import R from 'ramda'

import { isExist } from '../util'

const hasLocality = R.compose(
  isExist,
  R.propOr(null, 'localityName')
)

const city = R.ifElse(
  hasLocality,
  R.propOr(null, 'localityName'),
  R.propOr(null, 'zipCode')
)

const localityName = R.ifElse(R.isNil, R.always(''), city)

export const jobLocality = (job, place) => R.ifElse(
  R.prop('isRemote'),
  R.always('Remote'),
  () => localityName(place)
)(job)

export const jobsPlacesIds = R.compose(
  R.uniq,
  R.filter(isExist),
  R.pluck('placeId')
)



// WEBPACK FOOTER //
// ./src/helpers/jobs.js